import {
    DEALERBLOCKUNBLOCKUSER_SUCCESS,
    DEALERBLOCKUNBLOCKUSER_FAILED,
    RESET_DEALERBLOCKUNBLOCKUSER,
    LOADING_DEALERBLOCKUNBLOCKUSER,
    NETWORK_ERROR_DEALERBLOCKUNBLOCKUSER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERBLOCKUNBLOCKUSER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERBLOCKUNBLOCKUSER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERBLOCKUNBLOCKUSER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERBLOCKUNBLOCKUSER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERBLOCKUNBLOCKUSER:
            return (state = initialState);
        default:
            return state;
    }
};
